import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=b4a7cba0&scoped=true"
import script from "./number-input.vue?vue&type=script&lang=ts"
export * from "./number-input.vue?vue&type=script&lang=ts"
import style0 from "./number-input.vue?vue&type=style&index=0&id=b4a7cba0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a7cba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4a7cba0')) {
      api.createRecord('b4a7cba0', component.options)
    } else {
      api.reload('b4a7cba0', component.options)
    }
    module.hot.accept("./number-input.vue?vue&type=template&id=b4a7cba0&scoped=true", function () {
      api.rerender('b4a7cba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/number-input.vue"
export default component.exports